var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-10",staticStyle:{"margin-bottom":"100px"}},[_c('form-tuto',{attrs:{"typeFormulaire":'edition',"idTuto":_vm.tutoId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }